<tg-modal
    (close)="onClose()"
    size="wide">
    <tg-modal-header
        *ngIf="!submitted">
        <h2>
            Tell us what you think
        </h2>
        <p>
            We really want your feedback! We can't respond to it all, but are listening and are making changes where it's needed. If you need help with something, please
            <a
                href="https://help.trademe.co.nz/hc/en-us/requests/new?ticket_form_id=360000518892&id=undefined"
                target="_blank">contact our support team</a>.
        </p>
    </tg-modal-header>
    <tg-modal-body
        *ngIf="!submitted">
        <form
            #feedbackForm="ngForm"
            (ngSubmit)="submitFeedback()"
            name="feedbackForm"
            ngForm>
            <tg-toggle
                [(ngModel)]="feedbackSentiment"
                class="sentiment-toggle"
                label="Your feedback"
                name="feedbackSentiment">
                <tg-toggle-item
                    value="positive">
                    <tg-icon
                        alt="positive"
                        name="emo-happy"
                        tgStyle="success">
                    </tg-icon>
                </tg-toggle-item>
                <tg-toggle-item
                    value="neutral">
                    <tg-icon
                        alt="neutral"
                        name="emo-neutral"
                        tgStyle="warning">
                    </tg-icon>
                </tg-toggle-item>
                <tg-toggle-item
                    value="negative">
                    <tg-icon
                        alt="negative"
                        name="emo-sad"
                        tgStyle="danger">
                    </tg-icon>
                </tg-toggle-item>
            </tg-toggle>
            <div>
                <tg-input-container
                    label="Your comment"
                    [showLabel]="false">
                    <textarea
                        [(ngModel)]="feedbackText"
                        name="feedbackText"
                        placeholder="Share your thoughts"
                        rows="6"
                        maxlength="500"
                        tgTextInput></textarea>
                </tg-input-container>
            </div>
            <tg-row>
                <tg-col
                    sm="12"
                    md="6">
                    <button
                        (click)="onClose()"
                        fullWidth
                        tgButton2>
                        No thanks
                    </button>
                </tg-col>
                <tg-col
                    sm="12"
                    md="6">
                    <button
                        fullWidth
                        tgStyle="primary"
                        tgButton2
                        type="submit">
                        Send feedback
                    </button>
                </tg-col>
            </tg-row>
        </form>
    </tg-modal-body>
    <tg-modal-header
        *ngIf="submitted">
        <h2>
          Thanks for your thoughts
        </h2>
    </tg-modal-header>
    <tg-modal-body
        *ngIf="submitted">
        <p>
            We can't respond to it all, but are listening and are making changes where it's needed.
            If you need help with something, please
            <a class="tm-shell-feedback-modal__help-centre-button"
               href="https://help.trademe.co.nz/hc/en-us/requests/new?ticket_form_id=360000518892&id=undefined"
               target="_blank"
               rel="nofollower">contact our support team</a>.
        </p>
    </tg-modal-body>
</tg-modal>
